<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'SysTem'
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/layouts/system.vue